import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTooltipPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 8,
	viewBox: "0 0 24 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.3424 0)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8.24264 0.653453L2.82843 6.69309C2.07828 7.52989 1.06087 8 0 8H19.3137C18.2528 8 17.2354 7.52989 16.4853 6.69309L11.0711 0.653454C10.29 -0.217817 9.02369 -0.217819 8.24264 0.653453Z",
			fill: "currentColor"
		})
	})
});
export default SvgTooltipPin;
